__turbopack_context__.v({
  "center": "_3SiRZW_center",
  "container": "_3SiRZW_container",
  "cta": "_3SiRZW_cta",
  "header": "_3SiRZW_header",
  "headings": "_3SiRZW_headings",
  "left": "_3SiRZW_left",
  "text": "_3SiRZW_text",
});
